module.exports = __webpack_public_path__ + "img/beneficiary.bf1c28d3.svg";